function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u79FB\\u81F3\\u6700\\u524D",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(12.500000, 13.000000) scale(1, -1) translate(-12.500000, -13.000000) translate(3.000000, 2.000000)",
  fill: "#555555"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.65807804,0.937171137 C9.13519561,0.712710237 9.68799074,0.690264147 10.1802438,0.869832867 L10.341899,0.937171137 L17.9487431,4.51582594 C18.9039694,4.96521405 19.2958954,6.09453316 18.7581861,7.00601221 C18.6090813,7.25876207 18.3996989,7.4705119 18.1501508,7.62675154 L17.9957629,7.71371801 L17.095674,5.92770568 C17.0765735,5.93733166 17.0546746,5.95746159 17.0355952,5.98980327 C16.9687625,6.10309251 17.001221,6.2403156 17.0638451,6.30166722 L17.0973509,6.32555834 L9.5,2.75 L1.90262615,6.32555834 C1.91456835,6.31994011 1.92792879,6.30992999 1.94118393,6.2949006 L1.96079724,6.26851364 C2.03045421,6.15828915 2.0015898,6.0180771 1.93843854,5.95331254 L1.90430306,5.92770568 L1.0042142,7.71371801 C0.0602703648,7.23800274 -0.295939437,6.09577863 0.270106935,5.20007258 C0.426529331,4.95255137 0.641548548,4.74737489 0.894833651,4.59837444 L1.05123397,4.51582594 L8.65807804,0.937171137 Z",
  id: "Path",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.65807804,5.18705075 C9.13519561,4.96258985 9.68799074,4.94014376 10.1802438,5.11971248 L10.341899,5.18705075 L17.9487431,8.76570555 C18.9039694,9.21509367 19.2958954,10.3444128 18.7581861,11.2558918 C18.6090813,11.5086417 18.3996989,11.7203915 18.1609947,11.871022 L18.0145012,11.9539049 L12,15.1458575 L12,12.6055614 L12.534,12.605 L12.5312172,12.5997336 L16.698,10.387 L9.5,7 L2.301,10.387 L6.46878095,12.5997326 L6.465,12.605 L7,12.6055614 L7,15.1458575 L1.0042142,11.9635976 C0.0602703648,11.4878824 -0.295939437,10.3456582 0.270106935,9.4499522 C0.426529331,9.20243098 0.641548548,8.9972545 0.894833651,8.84825405 L1.05123397,8.76570555 L8.65807804,5.18705075 Z",
  id: "Path-Copy",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fillRule: "nonzero",
  transform: "translate(9.500000, 19.221089) rotate(-180.000000) translate(-9.500000, -19.221089) ",
  points: "5.34920863 20.2407434 9.5 16.6829222 13.6507914 20.2407434 12.3492086 21.7592566 9.5 19.317 6.65079137 21.7592566"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  fillRule: "nonzero",
  points: "10.5 9 10.5 20 8.5 20 8.5 9"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-3",
  points: "1 7.70791626 2.89386942 6.82071185 1.80692358 5.82255124"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-3-Copy",
  transform: "translate(17.046935, 6.765234) scale(-1, 1) translate(-17.046935, -6.765234) ",
  points: "16.1 7.70791626 17.9938694 6.82071185 16.9069236 5.82255124"
})));

function SvgToTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u79FB\u81F3\u6700\u524D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToTop);
export default __webpack_public_path__ + "static/media/toTop.702117b6.svg";
export { ForwardRef as ReactComponent };